module.exports = __webpack_public_path__ + "static/media/home-research-meets-technology-icon.3229943f.png";